export default __webpack_public_path__ + "static/media/2.38ba168b.png";